export const columnsHeadingFontKeys = {
    md: ['Primary/24_120_-1', null, null, 'Primary/32_100_-2'],
    lg: ['Primary/40_110_-2', null, 'Primary/48_100_-3', null, 'Primary/64_100_-4'],
};
